import request from '@/utils/request'
const BASE_URL = '/CostBook'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  GoodsList(params) {
    return request({
      url: BASE_URL + '/GoodsList',
      method: 'get',
      params
    })
  },
  GetCostPrice(params) {
    return request({
      url: BASE_URL + '/GetCostPrice',
      method: 'get',
      params
    })
  },
  MathCost(data) {
    return request({
      url: BASE_URL + '/MathCost',
      method: 'post',
      data
    })
  },
  GetSummaryList(data) {
    return request({
      url: BASE_URL + '/GetSummaryList',
      method: 'post',
      data
    })
  },
  RecountExistQuantity(data) {
    return request({
      url: BASE_URL + '/RecountExistQuantity',
      method: 'post',
      data
    })
  },
  // 收发存汇总表导出 
  StSummaryRptExport(data) {
    return request({
      url: BASE_URL + '/StSummaryRptExport',
      method: 'post',
      responseType: 'blob',
      data
    }).then(res => {
      var file = res.data;
      var disposition = res.headers['content-disposition'];
      // 

      var fileName = "导出";
      if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
        var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
        fileName = decodeURI(text);
      }

      if (navigator.msSaveBlob) {
        // IE10+下载
        navigator.msSaveBlob(file, fileName);
      } else {
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.target = "_blank";
        elink.href = URL.createObjectURL(file);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      }
      return Promise.resolve();
    });
  },
  // 库存成本台账导出 
  StRunningAccountRptExport(data) {
    return request({
      url: BASE_URL + '/StRunningAccountRptExport',
      method: 'post',
      responseType: 'blob',
      data
    }).then(res => {
      var file = res.data;
      var disposition = res.headers['content-disposition'];
      // 

      var fileName = "导出";
      if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
        var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
        fileName = decodeURI(text);
      }

      if (navigator.msSaveBlob) {
        // IE10+下载
        navigator.msSaveBlob(file, fileName);
      } else {
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.target = "_blank";
        elink.href = URL.createObjectURL(file);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      }
      return Promise.resolve();
    });
  },
  ListTotal(data) {
    return request({
      url: BASE_URL + '/ListTotal',
      method: 'post',
      data
    })
  },
}